import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  wcaGetCampaigns,
  wcaCreateCampaign,
  wcaGetCampaignById,
  wcaGetCampaignAnalytics,
} from '../../../api/wca/wca.capmaign.services';

export const wcaFetchCampaigns = createAsyncThunk(
  'campaign/fetchCampaigns',
  async (
    { metadataId, pageNo = 0, limit = 10, startDate, endDate, globalFilterValue },
    thunkAPI,
  ) => {
    try {
      const response = await wcaGetCampaigns(
        metadataId,
        pageNo,
        limit,
        startDate,
        endDate,
        globalFilterValue,
      );
      return response; // { count, rows }
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const wcaCreateNewCampaign = createAsyncThunk(
  'campaign/createCampaign',
  async ({ metadataId, data }, thunkAPI) => {
    try {
      const response = await wcaCreateCampaign(metadataId, data);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const wcaFetchCampaignById = createAsyncThunk(
  'campaign/fetchCampaignById',
  async ({ metadataId, campaignId }, thunkAPI) => {
    try {
      const response = await wcaGetCampaignById(metadataId, campaignId);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const wcaFetchCampaignCustomers = createAsyncThunk(
  'campaign/fetchCampaignCustomers',
  async ({ metadataid, campaignId, page = 0, limit = 10, status }, thunkAPI) => {
    try {
      const response = await wcaGetCampaignAnalytics(metadataid, campaignId, page, limit, status);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);
